<template>
  <div class="serviceTipsWrapper">
    <div class="header">
      <Header title="服务事项" />
    </div>
    <div class="tipsList">
      <!-- 服务事项内容 -->
      <div v-for="(staticsItem, index) in data?.staticsInfoList" :key="index" class="staticsItem">
        <img class="icon" :src="staticsItem.icon" alt="" />
        <div class="staticsInfo">
          <div class="top">
            <div class="service">{{ staticsItem.service }}</div>
            <div class="times">（{{ staticsItem.times }}）</div>
          </div>
          <div class="desc">{{ staticsItem.desc }}</div>
        </div>
      </div>
    </div>
    <div class="extraInfo">
      诊后病程服务费&nbsp;
      <span
        :class="{
          originalPrice: isValidFee(data?.preferentialPostServiceFee)
        }"
      >
        ¥{{ data?.postServiceFee }}
      </span>
      <template v-if="isValidFee(data?.preferentialPostServiceFee)">
        ，优惠后
        <span>&nbsp;¥{{ data?.preferentialPostServiceFee }}</span>
      </template>
      ，本价格根据全病程管理服务内容计算。
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import Header from '../../../components/Header'
defineProps({
  data: {
    type: Object,
    default: () => {}
  }
})
// 判断优惠后的价格是否有效
const isValidFee = value => {
  return !(parseFloat(value) === 0)
}
</script>

<style scoped lang="scss">
.serviceTipsWrapper {
  .header {
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #eff4f9;
  }

  .tipsList {
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    .staticsItem {
      width: 20%;
      min-width: 280px;
      display: flex;
      align-items: flex-start;
      margin: 0 40px 32px 0;
      .icon {
        width: 48px;
        height: 48px;
      }

      .staticsInfo {
        margin-left: 16px;

        .top {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          color: #1c1c1c;
          font-size: 14px;

          .service {
            margin-right: 8px;
            font-weight: 600;
          }
        }

        .desc {
          color: #636a70;
          font-size: 14px;
        }
      }
    }
  }

  .extraInfo {
    text-align: right;
    color: #c4c4c4;
    font-size: 12px;

    .originalPrice {
      text-decoration: line-through;
    }
  }
}
</style>
